import "./recaptcha.scss"
import { PageComponent } from "barba"

class Captcha {
    constructor({ node }) {
        this.node = node
        this.sitekey = this.node.dataset.sitekey
        this.captchaId = grecaptcha.render(
            this.node,
            { sitekey: this.sitekey }
        )
    }

    destroy() {
        if (this.captchaId) {
            grecaptcha.reset(this.captchaId)
        }

        delete this.node
        delete this.sitekey
        delete this.captchaId
    }
}

///////////////////////////////////////////////////////
// Cloudflare Turnstile alternative to Google ReCaptcha
///////////////////////////////////////////////////////

// Load external lib
const s = document.createElement('script');
s.src = `https://challenges.cloudflare.com/turnstile/v0/api.js?compat=recaptcha&onload=onloadTurnstileCallback&render=explicit&hl=${document.querySelector('html').lang || 'en'}`;
s.async = true;
s.defer = true;
document.head.appendChild(s);

// Trunstile lib loaded
window.onloadTurnstileCallback = () => {
    new PageComponent(".g-recaptcha", Captcha);
}